import { Check } from 'lucide-react'
import { cn } from '@/utils/cn'

export type SuccessHeroProps = {
  title: string
  subtitle?: string
  className?: string
}

export function SuccessHero({ title, subtitle, className }: SuccessHeroProps) {
  return (
    <div className={cn('rfid-success-hero', className)}>
      <div className="rfid-success-hero__icon">
        <Check size={36} strokeWidth={3} />
      </div>
      <h2 className="text-[22px] font-black text-emerald-500">{title}</h2>
      {subtitle ? (
        <p className="mt-2 px-3 text-[13px] font-semibold leading-5 text-muted-foreground">
          {subtitle}
        </p>
      ) : null}
    </div>
  )
}
